import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, map, shareReplay, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

interface RefreshResponse {
  accessToken?: string;
  accessTokenExpiresAt?: string;
}

@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
  private readonly accessTokenKey = 'deskplus.access_token';
  private readonly http: HttpClient;
  private refreshInFlight$: Observable<string> | null = null;

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  refreshAccessToken(): Observable<string> {
    if (this.refreshInFlight$) {
      return this.refreshInFlight$;
    }

    const refresh$ = this.http
      .post<RefreshResponse>(
        `${environment.apiBaseUrl}/api/auth/refresh`,
        {},
        { withCredentials: true }
      )
      .pipe(
        map((response) => {
          const token = response.accessToken?.trim();
          if (!token) {
            throw new Error('REFRESH_ACCESS_TOKEN_MISSING');
          }

          sessionStorage.setItem(this.accessTokenKey, token);
          return token;
        }),
        catchError((error) => {
          sessionStorage.removeItem(this.accessTokenKey);
          return throwError(() => error);
        }),
        finalize(() => {
          this.refreshInFlight$ = null;
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );

    this.refreshInFlight$ = refresh$;
    return refresh$;
  }
}
